<template>
  <div>
    <!-- Header Background Image -->
    <div
      class="profile-nav-bg"
      style="background-image: url('images/bg-profile.jpg')"
    ></div>
    <!-- / Header Background Image -->

    <!-- User Profile Card -->
    <a-card
      :bordered="false"
      class="card-profile-head"
      :bodyStyle="{ padding: 0 }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12" class="col-info">
            <a-avatar
              :size="74"
              shape="square"
              src="images/logoplaceholder.png"
            />
            <div class="avatar-info">
              <h4 class="font-semibold m-0">
                 Home Owners
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    class="fill-muted"
                    d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"
                    fill="#111827"
                  />
                  <path
                    class="fill-muted"
                    d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"
                    fill="#111827"
                  />
                </svg>
              </h4>

              <p>
                States Served
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    class="fill-muted"
                    d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"
                    fill="#111827"
                  />
                  <path
                    class="fill-muted"
                    d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"
                    fill="#111827"
                  />
                </svg>
              </p>
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
    <!-- User Profile Card -->

    <!-- Steps and forms -->
    <div class="mx-auto m-50 border" style="max-width: 800px">
      <!-- Steps -->
     
      <!-- / Steps -->

      <!-- Steps tabs and forms -->
      <div class="mb-50 header-solid">
        <!-- Step 1 : Product Information -->
        <!-- <a-card
          v-if="step == 0"
          :bordered="false"
          class="header-solid"
          :bodyStyle="{ paddingTop: 0 }"
          :headStyle="{ paddingBottom: '0' }"
        > -->
          <template >
            <h5 class="mb-0">Home Owner Information</h5>
          </template>

          <!-- Product Information form -->
          <a-form :form="form"    aria-autocomplete="on">
            <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="First Name" :colon="false">
                  <a-input
                     v-model="homeowner.firstName"
                    placeholder="eg. First Name"
                  />
                </a-form-item>
               
                  
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Last Name" :colon="false">
                  <a-input
                    v-model="homeowner.lastName"
                    placeholder="eg. Last Name"
                  />
                </a-form-item>
              </a-col>
            </a-row>
             <template >
            <h5 class="mb-0">Contact Details</h5>
          </template>
             <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="Contact Name" :colon="false">
                  <a-input
                     v-model="homeowner.contactDetails.contactName"
                    placeholder="eg. Contact Name"
                  />
                </a-form-item>
               
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Phone 1" :colon="false">
                  <a-input
                      v-model="homeowner.contactDetails.phone"
                    placeholder="eg. Phone 1"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            
             <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="Phone 2" :colon="false">
                  <a-input
                    v-model="homeowner.contactDetails.phone2"
                    placeholder="eg. Phone 2"
                  />
                </a-form-item>
               
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Email" :colon="false">
                  <a-input
                    v-model="homeowner.contactDetails.email"
                    placeholder="eg. Email"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Fax" :colon="false">
                  <a-input
                    v-model="homeowner.contactDetails.fax"
                    placeholder="eg. Fax"
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <template >
            <h5 class="mb-0">Spouse Reference</h5>
            </template>
              <a-row :gutter="[24]">
              <a-col :span="12">
               
                <a-form-item class="mb-10" label="Name" :colon="false">
                  <a-select
                     v-model="homeowner.spouseReference.id"
                    default-value=""
                  >
                   
                    <a-select-option value="">null</a-select-option>
                  
                  </a-select>
                </a-form-item>
              </a-col>
              
            </a-row>
            <template >
            <h5 class="mb-0">Address</h5>
            </template>
              <a-row :gutter="[24]">
              <a-col :span="12">
                <a-form-item class="mb-10" label="Address 1" :colon="false">
                  <a-input
                   v-model="homeowner.address.address1"
                    placeholder="eg. Address 1"
                  />
                </a-form-item>
               
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="Address 2" :colon="false">
                  <a-input
                    v-model="homeowner.address.address2"
                    placeholder="eg. Address 2"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="City" :colon="false">
                  <a-input
                  v-model="homeowner.address.city"
                    placeholder="eg. City"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="State" :colon="false">
                  <a-input
                    v-model="homeowner.address.state"
                    placeholder="eg. State"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="mb-10" label="ZipCode" :colon="false">
                  <a-input
                    v-model="homeowner.address.zipCode"
                    placeholder="eg. ZipCode"
                  />
                </a-form-item>
              </a-col>
            </a-row>
           <template >
            <h5 class="mb-0">Associations</h5>
            </template>
              <a-row :gutter="[24]">
              <a-col :span="12">
               
                <a-form-item class="mb-10" label="Associations" :colon="false">
                  <a-select
                   v-model="homeowner.associations.id"
                     default-value=""
                  >
                  
                     <a-select-option
                      v-for="state in associations"
                      :key="state.associationName"
                      :value="state.id"
                      >{{ state.associationName }}</a-select-option
                    >
                   
                  
                  </a-select>
                </a-form-item>
              </a-col>
              
            </a-row>


            
            <a-row :gutter="[24]">
              
              
              <a-col :span="24" class="text-right">
                 <p v-if="success" class="successful text-left">
                Home Owner has been successfully created.
              </p>
                   <a-button
                  type="primary"
                   @click="$router.push('homeowners-list')"
                   
                  class="px-25"
                  >Cancel</a-button
                >&nbsp;
                 <a-button
               
                  type="primary"
                  @click="handleSubmit"
                  class="px-25"
                   
                  >{{ submitState }}</a-button
                > 
                
              </a-col>
            </a-row>
          </a-form>
          <!-- / Product Information form -->
        <!-- </a-card> -->

        <!-- Step 2 : Address Information -->
        

        <!-- Step 3 : Contact Information -->
      

        <!-- Step 4 : Insurance Information -->
      

        <!-- Step 5 : Insurance Attachments -->
      
      </div>
      <!-- / Steps tabs and forms -->
    </div>
    <!-- / Steps and forms -->
  </div>
</template>
<script>

import { mapState } from 'vuex'

export default {
   computed: {
      ...mapState('associations', ['associations'])
    },
  
    mounted() {
            console.log('Component mounted.')
        },
        data() {
            return {
             success: false,
             submitState: "SAVE",
                homeowner: {
                firstName: '',
                lastName: '',
                contactDetails: {
                    contactName: '',
                    phone: '',
                    phone2: '',
                    email: '',
                    fax: ''
                },
                spouseReference: {
                    name: ''
                },
                address: {
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zipCode: ''
                },
                associations:[{
                id: '',
                name: ''

        }]

                 
                        }
            }
        },
  methods: {

   handleSubmit(e) {
    this.submitState = "Please Wait";
       setTimeout(() => {
           this.$store.dispatch("homeowners/addHomeOwner", JSON.stringify(this.homeowner)).then(() => {
        (res) => {
          console.log("okji",res);
        };
          this.success = true;
              this.submitState = "SAVE";
      });
        }, 2000);
      
    }, 

  },
 created () {
    		this.$store.dispatch('associations/getAll').then(()=> {
				this.data = this.associations;
			})  
  		}

      
}
</script>

<style>
 .border{
 max-width: 800px;
    border: 1px solid #d3d3d3;
    border-radius: 20px;
    margin-top: 1%;
    padding: 2% 2% 1%;
}
   
</style>

